export default {
    getBinQueryErrorMsg(value) {
        switch (value) {
        case 'InvalidPatVoucherCard':
            return 'wrongFlowMultibenefitsError';
        case 'InvalidPatVoucherTransaction':
            return 'verifyCardMultibenefitsError';
        default:
            return 'cardBrandNotSupported';
        }
    }
};